import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import useAdminUser from '../hooks/useAdminUser';
import { USER_ROUTES, ADMIN_ROUTES } from '../constants/routeConstants';
import LoadingSpinner from '../components/LoadingSpinner/LoadingSpinner';


const ProtectedRoute = ({ children, type = 'user', requiredRole }) => {
  const location = useLocation();
  const { user, loading: userLoading } = useAuth();
  const { adminUser, loading: adminLoading } = useAdminUser();

  if (type === 'admin') {
    if (adminLoading) {
      return <LoadingSpinner text="Checking session..." fullScreen />;
    }

    if (!adminUser) {
      return <Navigate to={ADMIN_ROUTES.LOGIN} state={{ from: location }} replace />;
    }

    if (requiredRole && adminUser.role?.trim().toLowerCase() !== requiredRole.toLowerCase()) {
      return <Navigate to={ADMIN_ROUTES.DASHBOARD} replace />;
    }

    return children;
  }


  if (userLoading) {
    return <LoadingSpinner text="Checking session..." fullScreen />;
  }

  if (!user) {
    return <Navigate to={USER_ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
